import { CLOUD_CLIENT } from '../constant/actionTypes';

const getCloudClientList = (state, action) => {
  switch (action.type) {
    case CLOUD_CLIENT.GET.INITIATE:
      return { isFetching: true, data: action.payload };
    case CLOUD_CLIENT.GET.SUCCESS:
      return { isFetching: false, data: action.payload };
    case CLOUD_CLIENT.GET.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getCloudClientList;
